export enum Views {
  HEAT_MAP = 'heat_map',
  WATCHLIST = 'watchlist',
  MATRIX = 'matrix',
  TRENDING = 'trending',
  RELATIONSHIP_BUILDING = 'relationship_building',
}
